import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-salary-edit',
  templateUrl: './salary-edit.component.html',
  styleUrls: ['./salary-edit.component.scss']
})
export class SalaryEditComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
